import React, { useContext } from "react";

export type DeviceInfo = {
  landscape: boolean,
  touchscreen: boolean,
  narrow: boolean,
  inBrowser: boolean,
  width: number,
  height: number
}

export const useDeviceInfo = () => useContext(DeviceContext);

export const DeviceContext = React.createContext<DeviceInfo>({
  landscape: false,
  touchscreen: false,
  narrow: false,
  inBrowser: false,
  width: 0,
  height: 0
});